module.exports = __webpack_public_path__ + "be1a90b6fc3184f6a923cb3720b92ec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8.jpg
// module id = 233
// module chunks = 0